import AdminCategoriesManager from "@/components/admin/AdminCategoriesManager";
import AdminSubcategoriesManager from "@/components/admin/AdminSubcategoriesManager";
import AdminTaxonomyQueue from "@/components/admin/AdminTaxonomyQueue";
import { router } from "expo-router";
import React, { useState } from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

type TabKey = "categories" | "subcategories" | "pending";

export default function AdminTaxonomyHome() {
  const [tab, setTab] = useState<TabKey>("categories");

  return (
    <SafeAreaView edges={["top"]} style={styles.safe}>
      <View style={styles.container}>
        <View style={styles.header}>
          <Pressable
            onPress={() => router.push("/admin" as any)}
            style={styles.backButton}
          >
            <Text style={styles.backButtonText}>← Admin Dashboard</Text>
          </Pressable>

          <Text style={styles.h1}>Admin · Taxonomy</Text>
        </View>

        <View style={styles.tabs}>
          <TabButton
            label="Categories"
            active={tab === "categories"}
            onPress={() => setTab("categories")}
          />

          <TabButton
            label="Subcategories"
            active={tab === "subcategories"}
            onPress={() => setTab("subcategories")}
          />

          <TabButton
            label="Pending"
            active={tab === "pending"}
            onPress={() => setTab("pending")}
          />
        </View>

        <View style={{ flex: 1 }}>
          {tab === "categories" ? <AdminCategoriesManager /> : null}
          {tab === "subcategories" ? <AdminSubcategoriesManager /> : null}
          {tab === "pending" ? <AdminTaxonomyQueue /> : null}
        </View>
      </View>
    </SafeAreaView>
  );
}

function TabButton({
  label,
  active,
  onPress,
}: {
  label: string;
  active: boolean;
  onPress: () => void;
}) {
  return (
    <Pressable
      onPress={onPress}
      style={[styles.tabBtn, active && styles.tabBtnActive]}
    >
      <Text style={[styles.tabText, active && styles.tabTextActive]}>
        {label}
      </Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  safe: {
    flex: 1,
    backgroundColor: "#fff",
  },

  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 10,
    backgroundColor: "#fff",
  },

  header: {
    marginBottom: 12,
  },

  backButton: {
    alignSelf: "flex-start",
    marginBottom: 8,
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 999,
    backgroundColor: "#F3F4F6",
  },

  backButtonText: {
    fontSize: 13,
    fontWeight: "900",
    color: "#111827",
  },

  h1: {
    fontSize: 22,
    fontWeight: "900",
  },

  tabs: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 12,
  },

  tabBtn: {
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 999,
    paddingVertical: 8,
    paddingHorizontal: 12,
    backgroundColor: "#fafafa",
  },

  tabBtnActive: {
    backgroundColor: "#111",
    borderColor: "#111",
  },

  tabText: {
    fontWeight: "900",
  },

  tabTextActive: {
    color: "white",
  },
});